import { create } from 'api/customers'
import LoaderButton from 'components/LoaderButton'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import Alert from 'react-bootstrap/Alert'
import { list as getPackages } from 'api/packages'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import DisplayLinkTypeHelp from './help/DisplayLinkTypeHelp'
import DisplaysMutedHelp from './help/DisplaysMutedHelp'

function Create(props) {
  const [loading, setLoading] = useState(true)
  const [packages, setPackages] = useState()

  useEffect(() => {
    const fetchData = async () => {
      const _packages = await getPackages(0, 1000)
      setPackages(_packages.data.map(x => ({ id: x.id, name: x.name })))
      setLoading(false)
    }

    fetchData()
  }, [])

  const [updating, setUpdating] = useState(false)
  const [values, setValues] = useState({
    name: '',
    package_id: '',
    display_link_type: 'download',
    displays_muted: '1',
    user_first_name: '',
    user_last_name: '',
    user_email: '',
  })
  const [errorMessage, setErrorMessage] = useState('')
  const [errors, setErrors] = useState({})

  const handleChange = event => {
    const { name, value } = event.target
    setValues({ ...values, [name]: value })
  }

  const handleSubmit = async event => {
    event.preventDefault()
    setErrorMessage('')
    setErrors({})

    setUpdating(true)
    const body = {
      name: values.name,
      package_id: values.package_id,
      display_link_type: values.display_link_type,
      displays_muted: values.displays_muted,
      user: {
        first_name: values.user_first_name,
        last_name: values.user_last_name,
        email: values.user_email,
      },
    }

    const res = await create(body)
    if (res.success) {
      props.history.push({ pathname: '/customers' })
    } else {
      setErrorMessage(res.data.message)
      setErrors(res.data.errors ?? {})
    }

    setUpdating(false)
  }

  if (loading) {
    return null
  }

  return (
    <div>
      <Container>
        <Row>
          <Col lg={12}>
            <Form onSubmit={handleSubmit}>
              <h1>Create Customer</h1>

              <div className='mb-5'>
                <Form.Group>
                  <Form.Label>Customer Name</Form.Label>
                  <Form.Control
                    isInvalid={errors.hasOwnProperty('name')}
                    name='name'
                    placeholder='Enter a name for this customer'
                    value={values.name}
                    onChange={handleChange}
                  />
                  {errors.hasOwnProperty('name') && (
                    <Form.Text className='text-danger'>{errors.name}</Form.Text>
                  )}
                </Form.Group>

                <Form.Group>
                  <Form.Label>Package</Form.Label>
                  <Form.Control
                    isInvalid={errors.hasOwnProperty('package_id')}
                    name='package_id'
                    as='select'
                    value={values.package_id}
                    onChange={handleChange}>
                    <option value=''>Please select</option>
                    {packages.map(x => (
                      <option key={x.id} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </Form.Control>
                  {errors.hasOwnProperty('package_id') && (
                    <Form.Text className='text-danger'>{errors.package_id}</Form.Text>
                  )}
                </Form.Group>

                <Form.Group>
                  <DisplayLinkTypeHelp /> <Form.Label>Display Link Type</Form.Label>
                  <Form.Control
                    as='select'
                    placeholder='Display Link Type'
                    name='display_link_type'
                    isInvalid={errors.hasOwnProperty('display_link_type')}
                    value={values.display_link_type}
                    onChange={handleChange}>
                    <option value='download'>Download</option>
                    <option value='browser'>Browser</option>
                    {errors.hasOwnProperty('display_link_type') && (
                      <Form.Text className='text-danger'>
                        {errors.display_link_type}
                      </Form.Text>
                    )}
                  </Form.Control>
                </Form.Group>

                <Form.Group>
                  <DisplaysMutedHelp /> <Form.Label>Displays Muted</Form.Label>
                  <Form.Control
                    as='select'
                    placeholder='Displays Muted'
                    name='displays_muted'
                    isInvalid={errors.hasOwnProperty('displays_muted')}
                    value={values.displays_muted}
                    onChange={handleChange}>
                    <option value='1'>Yes</option>
                    <option value='0'>No</option>
                    {errors.hasOwnProperty('displays_muted') && (
                      <Form.Text className='text-danger'>
                        {errors.displays_muted}
                      </Form.Text>
                    )}
                  </Form.Control>
                </Form.Group>
              </div>

              <h3>Initial User</h3>
              <Alert variant='info'>
                Customer's can manage their own users but you'll need to setup the first
                one below.
              </Alert>

              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  isInvalid={errors.hasOwnProperty('user.first_name')}
                  name='user_first_name'
                  placeholder="Enter the user's first name"
                  value={values.user_first_name}
                  onChange={handleChange}
                />
                {errors.hasOwnProperty('user.first_name') && (
                  <Form.Text className='text-danger'>
                    {errors['user.first_name']}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  isInvalid={errors.hasOwnProperty('user.last_name')}
                  name='user_last_name'
                  placeholder="Enter the user's last name"
                  value={values.user_last_name}
                  onChange={handleChange}
                />
                {errors.hasOwnProperty('user.last_name') && (
                  <Form.Text className='text-danger'>
                    {errors['user.last_name']}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  isInvalid={errors.hasOwnProperty('user.email')}
                  name='user_email'
                  placeholder="Enter the user's email"
                  value={values.user_email}
                  onChange={handleChange}
                />
                {errors.hasOwnProperty('user.email') && (
                  <Form.Text className='text-danger'>{errors['user.email']}</Form.Text>
                )}
              </Form.Group>

              {errorMessage && (
                <Alert className='mt-4' variant='danger'>
                  {errorMessage}
                </Alert>
              )}

              <Button
                variant='secondary'
                className='mt-4 mr-2'
                onClick={() => props.history.goBack()}>
                Cancel
              </Button>

              <LoaderButton
                className='mt-4'
                label='Create'
                loading={updating}
                variant='success'
                type='submit'
              />
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Create
